import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { problemQuestions, problemSignals } from '../../data/content';
export function Problem() {
  return <section className="bg-white px-5 py-14 md:py-20" data-id="element-271" data-mp="2rmaj0jbu2la8">
      <div className="mx-auto max-w-3xl" data-id="element-272" data-mp="2mo93g8dm943i">
        <SectionHeading title={<>
              A Postoperative Wound Can Change.{' '}
              <span className="text-teal" data-id="element-274" data-mp="2cr4czwcqmmgw">Your Assessment Workflow Shouldn&apos;t Be Improvised.</span>
            </>} data-id="element-273" data-mp="2mn7q1x94o5im" />

        <div className="mt-8 space-y-4 text-center text-[17px] leading-relaxed text-navy/80" data-id="element-275" data-mp="28qkhex7tbqwv">
          <p data-id="element-276" data-mp="23r7y2mg5h1z1">You&apos;re monitoring a surgical patient.</p>
          <p className="font-bold text-navy" data-id="element-277" data-mp="23ssrg8qqaevb">The wound looks different from the previous assessment.</p>
          <p data-id="element-278" data-mp="1z38hhm4igrh">There&apos;s a change in:</p>
        </div>
        <div className="mt-4 flex flex-wrap justify-center gap-2" data-id="element-279" data-mp="20eabbw0defy">
          {problemSignals.map(s => <span key={s} className="rounded-full bg-gold-light px-4 py-2 text-sm font-bold text-navy" data-id="element-280" data-mp="149ilsrdsscmt">
              {s}
            </span>)}
        </div>

        <p className="mt-8 text-center text-[17px] font-semibold text-navy" data-id="element-281" data-mp="vb5j8wzqwj1g">Now you need to organize your observations.</p>

        <ul className="mt-5 divide-y divide-navy/10 rounded-2xl border border-navy/10 bg-canvas" data-id="element-282" data-mp="10a0b0ofoxhxp">
          {problemQuestions.map(q => <li key={q} className="flex items-start gap-3 px-4 py-4" data-id="element-283" data-mp="1s0mvjut8h3c4">
              <HelpCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-teal" aria-hidden="true" data-id="element-284" data-mp="1rzuysgnwgzk9" />
              <span className="text-[15px] font-semibold leading-snug text-navy md:text-base" data-id="element-285" data-mp="1e8znkxpxi6di">{q}</span>
            </li>)}
        </ul>

        <div className="mt-8 rounded-2xl bg-navy p-6 text-center text-white" data-id="element-286" data-mp="26y6tihrppy8s">
          <p className="text-[17px] leading-relaxed" data-id="element-287" data-mp="26w2lpoqp0f38">
            The challenge isn&apos;t simply recognizing an abnormal finding.{' '}
            <strong className="text-gold" data-id="element-288" data-mp="2lkvvqrdcmpiv">
              It&apos;s organizing the information into a consistent professional workflow.
            </strong>
          </p>
          <p className="mt-3 text-sm text-white/75" data-id="element-289" data-mp="2bmg14ef44y4m">That&apos;s exactly what this blueprint is designed to support.</p>
        </div>

        <SectionCTA label="Fix My Workflow" data-id="element-290" data-mp="26mbk8naam1dv" />
      </div>
    </section>;
}